module.exports = __webpack_public_path__ + "img/tema-2-1.15db7621.svg";